// Admin > Usage. Same per-call report as the merchant Billing section, across
// all customers, with an optional customer filter and CSV export.
import React, { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import API_BASE from "../config/api";
import UsageReport from "../components/UsageReport";

const AdminUsage = () => {
  const [merchantList, setMerchantList] = useState([]);
  const [customerId, setCustomerId] = useState("");

  useEffect(() => {
    // Best-effort: the report works without the list (shows all customers).
    axios
      .get(`${API_BASE}/fetchMerchantForMode`)
      .then(({ data }) => setMerchantList(data?.data || []))
      .catch((err) => console.error("Usage: couldn't load merchants", err));
  }, []);

  const options = useMemo(
    () =>
      Array.from(
        new Map(
          merchantList
            .filter((m) => m.customer_id)
            .map((m) => [m.customer_id, { label: m.full_name || m.name || "Unnamed", value: m.customer_id }])
        ).values()
      ),
    [merchantList]
  );

  return (
    <div className="modSpace">
      <h2>Usage</h2>
      <p style={{ color: "#6b7280", marginBottom: 12 }}>OpenAI API runs: timestamp, input, output and total tokens.</p>

      <Select
        showSearch
        allowClear
        virtual={false}
        style={{ width: 320, marginBottom: 16 }}
        placeholder="All customers"
        value={customerId || undefined}
        onChange={(v) => setCustomerId(v || "")}
        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
        options={options}
      />

      <UsageReport scope="admin" customerId={customerId} showCustomer />
    </div>
  );
};

export default AdminUsage;
